(() => {
  'use strict';
  if (window.__phBrandsV39Loaded) return;
  window.__phBrandsV39Loaded = true;
  function normalize(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  }
  function init(root) {
    if (root.dataset.phInitialized) return;
    const tools = root.querySelector('.ph-brand-tools');
    const input = root.querySelector('input[type="search"]');
    const clear = root.querySelector('[data-ph-brand-clear]');
    const countNode = root.querySelector('[data-count]');
    const empty = root.querySelector('[data-empty]');
    const buttons = Array.from(root.querySelectorAll('[data-letter]'));
    if (!tools || !input || !clear || !countNode || !empty) return;
    root.dataset.phInitialized = 'true';
    const seen = new Map();
    root.querySelectorAll('[data-vendor]').forEach(item => {
      const key = normalize(item.dataset.vendor);
      if (!seen.has(key)) { seen.set(key, item); return; }
      const first = seen.get(key).querySelector('a');
      const link = item.querySelector('a');
      if (first && link && item.dataset.vendor !== item.dataset.vendor.toUpperCase()) {
        first.href = link.href;
        first.textContent = link.textContent;
      }
      item.remove();
    });
    const items = Array.from(root.querySelectorAll('[data-vendor]'));
    let letter = '';
    function initial(item) {
      const first = normalize(item.querySelector('a').textContent).charAt(0).toUpperCase();
      return /^[0-9]$/.test(first) ? '0–9' : first;
    }
    const available = new Set(items.map(initial));
    buttons.forEach(button => { button.disabled = !!button.dataset.letter && !available.has(button.dataset.letter); });
    function update() {
      const query = normalize(input.value);
      let count = 0;
      items.forEach(item => {
        const match = (!query || normalize(item.querySelector('a').textContent).includes(query)) && (!letter || initial(item) === letter);
        item.hidden = !match;
        if (match) count += 1;
      });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.letter === letter)));
      clear.hidden = !query && !letter;
      empty.hidden = count > 0;
      countNode.textContent = count + ' ' + root.dataset.resultLabel;
    }
    // A typed query searches all brands, rather than an accidentally retained A–Z subset.
    input.addEventListener('input', () => { letter = ''; update(); });
    buttons.forEach(button => button.addEventListener('click', () => { letter = button.dataset.letter; update(); }));
    clear.addEventListener('click', () => { input.value = ''; letter = ''; update(); input.focus(); });
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape') { input.value = ''; letter = ''; update(); }
    });
    tools.hidden = false;
    update();
  }
  function start() { document.querySelectorAll('[data-ph-brand-directory]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', start);
})();
